<template>
  <div class="app-shell">
    <div class="app-wrapper">
      <navbar />
      <main class="main-container">
        <app-main />
      </main>
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar'
import AppMain from './components/AppMain'

export default {
  name: 'Layout',
  components: {
    Navbar,
    AppMain
  }
}
</script>

<style scoped>
.app-wrapper {
  min-height: 100vh;
  width: 100%;
  padding: 24px;
  position: relative;
}

.main-container {
  min-height: calc(100vh - 132px);
}

@media (max-width: 1200px) {
  .app-wrapper {
    padding: 18px;
  }
}

@media (max-width: 768px) {
  .app-wrapper {
    padding: 12px;
  }
}
</style>
